// Mobile bottom tab bar (<768px) — Dashboard, Inbox, Broadcast, Contacts, Bots.
// Hidden at md+ where the sidebar takes over (PRD §6.2).
import { NavLink } from 'react-router-dom';
import { useI18n } from '../../lib/i18n';
import { cn } from '../../lib/cn';
import { TAB_ITEMS } from '../../lib/nav';

export default function MobileTabBar() {
  const { t } = useI18n();

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 flex border-t border-line bg-white pb-2.5 pt-1.5 transition-colors dark:border-slate-800 dark:bg-slate-900 md:hidden">
      {TAB_ITEMS.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              cn(
                'flex flex-1 flex-col items-center gap-0.5 py-1 text-[10px] font-medium text-slate-500 transition-colors dark:text-slate-400',
                isActive && 'font-bold text-brand dark:text-brand-tint',
              )
            }
          >
            <Icon size={20} className="shrink-0" />
            <span>{t(item.key)}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
